export default "__VITE_ASSET__DrjDEtsw__"